import { render } from "./GCardPage.vue?vue&type=template&id=2f9abfb1"
const script = {}

const cssModules = {}
import style0 from "./GCardPage.vue?vue&type=style&index=0&id=2f9abfb1&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__